import API from '@/api/api';
import {computed} from 'vue';
import {useQuery} from '@tanstack/vue-query';
import {storeToRefs} from 'pinia';
import {useUserStore} from '@/stores/userStore';
import {parseZodSchema} from '@/api/models/parseZodSchema';
import {
    featureFlagResponseModel,
    type FeatureFlagResponse,
} from '@/api/models/featureFlags/featureFlagModel';
import {featureFlagQueryKey} from '@/api/queries/keys/featureFlagKeys';

export function useFeatureFlagQuery() {
    const {isAuthenticated, user} = storeToRefs(useUserStore());

    const userId = computed(() => user.value?.id);
    const enabled = computed(() => isAuthenticated.value && !!userId.value);

    const {data, isPending} = useQuery({
        queryKey: featureFlagQueryKey(userId),
        queryFn: () =>
            API.get('/api/unleash', true, true)
                .then(API.handle)
                .then(data => parseZodSchema(data, featureFlagResponseModel)),
        enabled,
        meta: {persist: true},
        staleTime: 0,
        refetchOnWindowFocus: false,
    });

    const featureFlagResponse = computed(() => data.value ?? ({} as FeatureFlagResponse));
    const isLoading = computed(() => enabled.value && isPending.value);

    return {featureFlagResponse, isLoading};
}
